// © 2025 PyLocus. All rights reserved. Unauthorized use prohibited.
document.addEventListener('DOMContentLoaded', () => {

    const modal = document.getElementById('complaint-modal');
    const addComplaintBtn = document.getElementById('add-complaint-btn');
    const closeBtn = document.querySelector('.modal .close-btn');

    const previewTitle = document.getElementById('preview-title');
    const previewCategory = document.getElementById('preview-category-tag');
    const previewImg = document.getElementById('preview-img') as HTMLImageElement;
    const previewDesc = document.getElementById('preview-desc');
    const inputTitle = document.getElementById('title') as HTMLInputElement;
    const inputCategory = document.getElementById('category') as HTMLSelectElement;
    const inputDescription = document.getElementById('description') as HTMLTextAreaElement;
    const inputFile = document.getElementById('image') as HTMLInputElement;
    const dropzone = document.getElementById('image-dropzone');
    const dropzoneText = document.getElementById('dropzone-text');
    const imagePreviewList = document.getElementById('image-preview-list');
    const inputLocation = document.getElementById('location') as HTMLInputElement;

    const stepBack = document.getElementById('step-back') as HTMLButtonElement;
    const stepNext = document.getElementById('step-next') as HTMLButtonElement;
    const latInput = document.getElementById('lat-input') as HTMLInputElement;
    const lngInput = document.getElementById('lng-input') as HTMLInputElement;

    let currentStep = 1;

    function showStep(step: number) {
        document.querySelectorAll('.form-step').forEach(el => (el as HTMLElement).style.display = 'none');
        const target = document.querySelector(`.form-step[data-step="${step}"]`) as HTMLElement;
        if (target) target.style.display = '';

        document.querySelectorAll('.step-dot').forEach(d => {
            const s = parseInt(d.getAttribute('data-step') || '0');
            (d as HTMLElement).style.background = s <= step ? '#2563eb' : '#e2e8f0';
        });
        document.querySelectorAll('.step-label').forEach(l => {
            const s = parseInt(l.getAttribute('data-step') || '0');
            (l as HTMLElement).style.color = s <= step ? '#2563eb' : '#94a3b8';
        });

        stepBack.style.display = step > 1 ? '' : 'none';
        stepNext.textContent = step === 4 ? 'Pošalji prijavu' : 'Dalje';
        stepNext.type = 'button';
        currentStep = step;

        if (step === 4) {
            (window as any)._onMapStep?.();
        }
    }

    function getSelectedFiles(): number {
        return inputFile.files ? inputFile.files.length : 0;
    }

    function updateImagePreview() {
        if (!inputFile.files || !imagePreviewList || !previewImg || !dropzoneText) return;
        const count = inputFile.files.length;
        dropzoneText.textContent = count >= 3 ? `${count} slika odabrano` : `${count}/3 slika odabrano`;
        imagePreviewList.innerHTML = '';
        if (count > 0) {
            const file = inputFile.files[0];
            if (file.type.startsWith('image/')) {
                const reader = new FileReader();
                reader.onload = (e) => { if (previewImg && e.target) previewImg.src = e.target.result as string; };
                reader.readAsDataURL(file);
            }
            for (let i = 0; i < Math.min(count, 5); i++) {
                const thumb = document.createElement('img');
                thumb.style.cssText = 'width:48px;height:48px;border-radius:8px;object-fit:cover;border:1px solid #e2e8f0;';
                const fr = new FileReader();
                fr.onload = (e) => { thumb.src = e.target?.result as string; };
                fr.readAsDataURL(inputFile.files[i]);
                imagePreviewList.appendChild(thumb);
            }
            if (count > 5) {
                const more = document.createElement('span');
                more.style.cssText = 'width:48px;height:48px;border-radius:8px;background:#f1f5f9;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:600;color:#64748b;';
                more.textContent = `+${count - 5}`;
                imagePreviewList.appendChild(more);
            }
        }
    }

    function resetFileInput() {
        if (inputFile) inputFile.value = '';
        if (imagePreviewList) imagePreviewList.innerHTML = '';
        if (dropzoneText) dropzoneText.textContent = 'Klikni za odabir slika (min 3)';
        if (previewImg) previewImg.src = '/static/assets/logo.png';
    }

    if (modal && addComplaintBtn) {
        addComplaintBtn.addEventListener('click', () => {
            if (!document.getElementById('profile-menu-btn')) {
                window.location.href = '/login';
                return;
            }
            modal.classList.add('show');
            document.body.style.overflow = 'hidden';
            showStep(1);
            resetFileInput();
            if (previewTitle) previewTitle.textContent = 'Naslov prijave';
            if (previewDesc) previewDesc.style.display = 'none';

        });

        if (closeBtn) {
            closeBtn.addEventListener('click', () => {
                modal.classList.remove('show');
                document.body.style.overflow = '';
            });
        }
        window.addEventListener('click', (event) => {
            if (event.target === modal) {
                modal.classList.remove('show');
                document.body.style.overflow = '';
            }
        });
    }

    if (stepNext) {
        stepNext.addEventListener('click', () => {
            if (currentStep === 4) {
                if (form) form.requestSubmit();
                return;
            }
            if (currentStep === 1 && getSelectedFiles() < 3) {
                alert('Potrebno je odabrati najmanje 3 slike.');
                return;
            }
            if (currentStep === 2 && !inputTitle.value.trim()) {
                alert('Unesite naslov prijave.');
                inputTitle.focus();
                return;
            }
            if (currentStep === 3 && !inputDescription.value.trim()) {
                alert('Unesite opis problema.');
                inputDescription.focus();
                return;
            }
            if (currentStep < 4) {
                showStep(currentStep + 1);
            }
        });
    }

    if (stepBack) {
        stepBack.addEventListener('click', () => {
            if (currentStep > 1) showStep(currentStep - 1);
        });
    }

    const loadingOverlay = document.getElementById('complaint-loading-overlay');

    function showLoading(show: boolean) {
        if (loadingOverlay) loadingOverlay.style.display = show ? 'flex' : 'none';
        if (stepNext) stepNext.disabled = show;
    }

    const form = document.getElementById('new-complaint-form') as HTMLFormElement;
    if (form) {
        form.addEventListener('submit', async (e) => {
            e.preventDefault();
            showLoading(true);

            try {
                const resp = await fetch('/api/add_complaint', {
                    method: 'POST',
                    body: new FormData(form),
                });
                const data = await resp.json();

                if (data.success) {
                    if (modal) modal.classList.remove('show');
                    document.body.style.overflow = '';
                    window.location.reload();
                } else {
                    showLoading(false);
                    const msg = data.message || 'Došlo je do greške.';
                    const existing = form.querySelector('.form-error-msg');
                    if (existing) existing.remove();
                    const errEl = document.createElement('div');
                    errEl.className = 'form-error-msg';
                    errEl.style.cssText = 'padding:12px;background:#fef2f2;color:#dc2626;border-radius:10px;font-size:13px;font-weight:500;text-align:center;margin-top:12px;';
                    errEl.textContent = msg;
                    document.getElementById('step-nav')?.appendChild(errEl);
                }
            } catch (err) {
                showLoading(false);
                const existing = form.querySelector('.form-error-msg');
                if (existing) existing.remove();
                const errEl = document.createElement('div');
                errEl.className = 'form-error-msg';
                errEl.style.cssText = 'padding:12px;background:#fef2f2;color:#dc2626;border-radius:10px;font-size:13px;font-weight:500;text-align:center;margin-top:12px;';
                errEl.textContent = 'Mrežna greška. Pokušajte ponovno.';
                document.getElementById('step-nav')?.appendChild(errEl);
            }
        });
    }

    

    window.addEventListener('pageshow', () => {
        const btn = document.getElementById('step-next') as HTMLButtonElement;
        if (btn && btn.disabled) {
            btn.disabled = false;
            btn.textContent = 'Pošalji prijavu';
        }
        const submitBtn = document.getElementById('submit-complaint-btn') as HTMLButtonElement;
        if (submitBtn && submitBtn.disabled) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Pošalji prijavu';
        }
    });

    if (inputTitle && previewTitle) {
        inputTitle.addEventListener('input', (e) => {
            const val = (e.target as HTMLInputElement).value;
            previewTitle.textContent = val.trim() || 'Naslov tvoje prijave...';
        });
    }

    if (inputCategory && previewCategory) {
        inputCategory.addEventListener('change', () => {
            previewCategory.textContent = inputCategory.value.toUpperCase() || 'PRIJAVA';
        });
    }

    if (inputDescription && previewDesc) {
        inputDescription.addEventListener('input', () => {
            const val = inputDescription.value.trim();
            if (val) {
                previewDesc.textContent = val;
                previewDesc.style.display = '';
            } else {
                previewDesc.style.display = 'none';
            }
        });
    }

    if (inputFile && previewImg && dropzone) {
        inputFile.addEventListener('change', updateImagePreview);
        dropzone.addEventListener('click', () => {
            inputFile.value = '';
            inputFile.click();
        });

        ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
            dropzone.addEventListener(eventName, (e) => { e.preventDefault(); e.stopPropagation(); }, false);
        });
        ['dragenter', 'dragover'].forEach(eventName => {
            dropzone.addEventListener(eventName, () => dropzone.classList.add('dragging'), false);
        });
        ['dragleave', 'drop'].forEach(eventName => {
            dropzone.addEventListener(eventName, () => dropzone.classList.remove('dragging'), false);
        });
        dropzone.addEventListener('drop', (e: DragEvent) => {
            const dt = e.dataTransfer;
            if (dt && dt.files) {
                inputFile.files = dt.files;
                updateImagePreview();
            }
        }, false);
    }

});
